// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pacific-island-selectree-banner-container {\n  background-image: url(\"/images/home_palm.png\");\n}\n", ""]);
// Exports
module.exports = exports;
